import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import {SmartGridService} from '@core/services/smart-grid.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {SnackBarService} from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {FlowChartResponseComponent} from '../flow-chart-response/flow-chart-response.component';
import {DetailsInstructionService, InstructionDetailsSourceViewType} from '@shared/services/details-instruction-service';


@Component({
    standalone: false,
    selector: 'particle-flow-chart-response-group-view',
  templateUrl: './flow-chart-response-group-view.component.html',
  styleUrls: ['./flow-chart-response-group-view.component.scss']
})
export class FlowChartResponseGroupViewComponent implements OnInit, OnDestroy {
  @Input() section: any;
  @Input() surveyId: string;
  @Input() sourceType: string;
  @Input() fieldDefinitions: any;
  unsubscribe$ = new Subject<void>();
  @Input() rowItem: any;
  @ViewChild('flowChartResponse') flowChartDesigner: FlowChartResponseComponent;

  constructor(private detailsInstructionService: DetailsInstructionService) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openDetailsAndInstructions(b: boolean) {
    // this.detailsInstructionService.openDetailsInstructionPopUp(this.sourceType, this.section.sourceFieldSectionId);
    const header = '<div style="margin-bottom: 20px;font-weight: 500;font-size: .95rem;">' + this.section.title + '</div>';
    this.detailsInstructionService.getDetailsInstruction(InstructionDetailsSourceViewType.flowchart, this.sourceType, this.section.title).subscribe(data => {
      if (data) {
        const viewDetailObj = {};
        viewDetailObj['notes'] = header;
        if (data.details) {
          viewDetailObj['notes'] += data.details;
        }
        if (data.attachments) {
          viewDetailObj['attachments'] = data.attachments;
        }
        this.detailsInstructionService.setViewDetail(viewDetailObj,true);
      } else {
        const detailMessage = '<p><strong>No additional details available.</strong></p>';
        const fieldDetail = header + detailMessage;
        const viewDetailObj = {};
        viewDetailObj['notes'] = fieldDetail;
        this.detailsInstructionService.setViewDetail(viewDetailObj,true);
      }
    });
  }
}
